module.exports = __webpack_public_path__ + "media/images/flags/gb-ad3aa4f8661cd353439d28fecaefc345.svg";